/**
 * OrderStatus describes the global status of the checkout
 * IDLE -> SUBMITTING -> PROCESSING -> SUCCEEDED || FAILED
 */

export enum OrderStatus {
  IDLE = 'idle', // default status
  SUBMITTING = 'submitting', // action button clicked. (temp state)
  PROCESSING = 'processing', // order is processing
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}

export type Status = {
  status: string
  error: null | string
}
